import { Component, OnInit, ViewEncapsulation, ViewChild, TemplateRef, Input , EventEmitter, Output} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule , FormControl } from '@angular/forms';
import { NotificationService } from '../../../services/notification.service';
import { LocalStorage, LocalStorageService } from 'ngx-store';
import { Router } from '@angular/router';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import { ImageResult } from 'ngx-image2dataurl';

//Service
import { BillsService } from '../../../services/bills.service';
import { FilesService } from '../../../services/files.service';
import { XeroService } from 'src/lib/integrations/xero/xero.service';


//Model
import { Bill , BillPayment } from '../../../model/bills.model';
import { ThemeSetting } from 'src/app/model/users.model';

@Component({
    selector: 'app-billpayments',
    templateUrl: './billpayments.component.html',
    encapsulation: ViewEncapsulation.None,
    providers: [ BillsService, FilesService ],
    exportAs: 'app-billpayments',
})
  
export class BillPaymentsComponent implements OnInit {
    @Output() closeModal : EventEmitter<any>= new EventEmitter<any>();
    @Input() bill: Bill;
    @ViewChild('modalAddUpdatePayment', {static: false}) modalAddUpdatePayment: TemplateRef<any>;
    @ViewChild('modalDeletePayment', {static: false}) modalDeletePayment: TemplateRef<any>;

    public s_theme: ThemeSetting;
    public spinner: boolean = false;
    public frm_payment: FormGroup;
    public current_user :number;
    public b_payments = [];
    public payment_types = [];

    public modalRef: NgbModalRef;
    public isEditMode: boolean = false;
    public fileStoragePath : string ='';
    public prefix_payments : string = 'bill_payments';

    b_columns = [
        { prop: 'id' },              
        { prop: 'bill_id' },           
        { prop: 'date' },    
        { prop: 'description' },        
        { prop: 'reference_no' },      
        { prop: 'file' },    
        { prop: 'user_created' },      
        { prop: 'user_updated' },            
        { prop: 'payment_type_name' },    
        { prop: 'paid_amount' },        
      ];
    
    public balance : number = 0;
    public amount_paid : number = 0;

    public frmFile: any;
    public fileExists :boolean;
    public fileRemove :boolean;
    public oldFile: string;
    public bill_payment: BillPayment;
    public current_payment :BillPayment;

    public xero_payments= [];
    public xero_total: number = 0;
    public is_xero : boolean = false;

    constructor(private http: HttpClient, 
    			private _fb: FormBuilder, 
    			private modal: NgbModal, 
                private svc_bills: BillsService,
			  	private toastr: NotificationService,
                private svc_storage: LocalStorageService,
                private router : Router,
                private fileService: FilesService,
                private xero    : XeroService
 				){
	}

    ngOnInit() {
        this.s_theme = this.svc_storage.get('themeSettings');
        this.current_user = this.svc_storage.get('user').id;
        this.fileStoragePath = this.svc_storage.get('url').fileStorage;

        this.initializeForm();
        this.getBillPayments();
        //console.log(this.bill);

        this.xero.status$.subscribe(xs=>{
            this.is_xero = xs.valueOf();

            if(this.is_xero){
                this.xero.getBill(this.bill.id).subscribe(result=>{
                    if(result['Payments']){
                        this.xero_payments = result['Payments'];

                        this.xero_payments.forEach(payment=>{
                            this.xero_total += payment['Amount'];
                            
                            var date = payment['Date'].replace('/Date(','');
                            date = date.replace(')/','');
                            var date2 = new Date(parseInt(date));
                            payment['Date'] = date2;

                        });
                    };
                })
            }
        })
    }

    initializeForm(){
        const currencyRegex = '^[+]?[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{2})?$';
        this.frm_payment = this._fb.group({
            id: [''],
            bill_id: [this.bill.id],
            date: ['', Validators.required],
            description: ['', Validators.required],
            file: [''],
            paid_amount: ['', [Validators.required, Validators.pattern(currencyRegex)]],
            payment_type_id: ['', Validators.required],
            reference_no: [''],
            created_by: ['', Validators.required],
            updated_by: [''],
            bill_total_cost: [this.bill.total_amount]
        });
        this.resetFileVariables();
    }

    getBillPayments(){
        this.balance = 0;
        this.amount_paid = 0;
        this.svc_bills.getBillPayments(this.bill.id).subscribe(result => {
            this.payment_types = result["payment_types"];
            this.b_payments = result["bill_payments"];

            if(this.b_payments.length){
                this.b_payments.forEach(bp=>{
                    this.amount_paid += bp.paid_amount;
                });
                this.balance = this.bill.total_amount - this.amount_paid;
            }
        })
    }

    onSubmit(frm_value) {
        this.spinner = true;
        frm_value.bill_id = this.bill.id;
        frm_value.bill_total_cost = this.bill.total_amount;

        if(this.isEditMode == false){
            this.svc_bills.createBillPayment(frm_value).subscribe(result=>{
                if(result['error'] == true){
                this.toastr.showError(result['error_message'], 'Bill Payment Error');
                }else{
                    this.bill_payment = result['bill_payment'];
                    this.uploadFile(this.bill_payment.file);
                    this.toastr.showSuccess(result['message'], 'Bill Payment Success');
                }
                
                this.getBillPayments();
                this.closeFrmPayment();
            });

        }else{
            frm_value.updated_by = this.current_user;
            this.svc_bills.updateBillPayment(frm_value).subscribe(result=>{
                if(result['error'] == true){
                this.toastr.showError(result['error_message'], 'Bill Payment Error');
                }else{
                    this.bill_payment = result['bill_payment'];
                    this.uploadFile(this.bill_payment.file);
                    this.toastr.showSuccess(result['message'], 'Bill Payment Success');
                }
                
                this.getBillPayments();
                this.closeFrmPayment();
            });
        }

      
    
    }
    
    close(){
        this.closeModal.emit();
    }

    closeFrmPayment(){
        this.frm_payment.reset();
        this.modalRef.close();
        this.spinner = false;
    }

    closeFrmDelete(){
        this.current_user = null;
        this.modalRef.close();
        this.spinner = false;
    }

    openModalAddUpdatePayment(payment: BillPayment){
        this.spinner = false;
        this.isEditMode = false;
        if (payment) {
            this.frm_payment.patchValue(payment);
            this.frm_payment.controls.updated_by.setValue(this.current_user);
            this.isEditMode = true;

            if (payment.file != null && payment.file != '')
            {
              this.oldFile = payment.file;
              this.fileExists = true;
            }
        }else{
            this.frm_payment.reset();
            this.frm_payment.controls.created_by.setValue(this.current_user);
        }
        
        this.bill_payment = payment;
        this.modalRef = this.modal.open(this.modalAddUpdatePayment, { container: '.app', centered: true, size: 'lg', backdrop: 'static'});
       
    }

    public getFile(event){

        var billFillename;
    
        if (event == '' || event == null){
            billFillename = event
        }else{
            var file : ImageResult;
            file = event;
            billFillename =  file.file.name;
            this.frmFile = event;
        }
        
        this.frm_payment.controls.file.setValue(billFillename);

        var imgFilename;
   
    };

    public uploadFile(filename){
        if (this.frmFile){
        
            this.fileService.uploadRawFileWithRename(this.prefix_payments, this.frmFile, filename).subscribe(file=>{
                if (file["data"] !== this.bill_payment.file) {
                    this.bill_payment.file = file["data"];
                    this.svc_bills.updateBillPaymentFileName(this.bill_payment).subscribe(data => {
                        this.getBillPayments();
                    });
                }
            });
        
        }

        this.frmFile = '';

        //handling files if replaced, old file is removed from server
        if(this.fileRemove == true){
            this.deleteFile(this.oldFile);
        };

        this.resetFileVariables();

    }

    public removeFile(){
        this.fileExists  = false;
        this.frm_payment.controls.file.setValue('');
        this.fileRemove = true;
    }

    public deleteFile(filename){
        this.fileService.deleteFile(this.prefix_payments, filename).subscribe(result=>{console.log(result);});
        this.fileRemove = false;
    }

    public resetFileVariables(){
        this.fileExists = false;
        this.fileRemove  = false;
        this.oldFile = '';
    }

    openModalDelete(bill_payment){
        this.spinner = false;
        this.current_payment = bill_payment;
        this.current_payment.updated_by = this.current_user;
        this.modalRef = this.modal.open(this.modalDeletePayment, { container: '.app', size: 'sm', backdrop: 'static' });

    }

    async deletePayment() {
        this.spinner = true;

        this.current_payment.updated_by = this.current_user;
        await this.svc_bills.deleteBillPayment(this.current_payment).toPromise().then(result => {
           if(result['error'] == false){
               this.toastr.showSuccess(result['message'], 'Delete Payment Success');
               if(this.current_payment.file !== '' || this.current_payment.file !== null ){
                    this.fileService.deleteFile(this.prefix_payments, this.current_payment.file).subscribe();
               }
           }else{
            this.toastr.showError(result['message'], 'Delete Payment Error')
           }
        });    
        this.getBillPayments();
        this.modalRef.close()
        this.spinner = false;
    }

    isAmt() {
		const frmCtrl = (<any>this.frm_payment);

		if (frmCtrl.controls.paid_amount.valid)
			return true;
		else return false;
    }

    public formatDate(inDate: string) {
        let formatedDate: Date;
        if (inDate && !inDate.includes('0000') ) {
          formatedDate = new Date(inDate.replace(/-/g, "/"));
          return formatedDate;
        }
        else return null;
    }

    
}